import { Mode, philipsMode } from '../common/types';

export enum ApplicationResolution {
  HD = '720p',
  FULLHD = '1080p',
}

const isOldPhilips = (mode: Mode, userAgent: string = ''): boolean => {
  return mode === philipsMode && !userAgent.toLowerCase().includes('titanos');
};

export function createApplicationResolution(
  from: string,
  mode: Mode,
  userAgent?: string
): ApplicationResolution {
  return from === '1080p' && !isOldPhilips(mode, userAgent)
    ? ApplicationResolution.FULLHD
    : ApplicationResolution.HD;
}

export const rootFontSize = {
  [ApplicationResolution.HD]: 16,
  [ApplicationResolution.FULLHD]: 24,
};
